// Pure: turn a deal's portalForms map into per-form progress rows.
// Mirrors the rule the deal-detail Client Portal panel and the client-facing
// portal both use, so the three screens can never disagree:
//   submitted  — the server stamped submittedAt on /portal/submit
//   started    — no submittedAt, but at least one visible field has an answer
//   not-started
// Read-only forms (all fields are videos) can't be submitted, so they're
// excluded from the "X of Y" count — otherwise it could never reach Y.

import { isFieldVisible } from "./portalForms";

const isEmptyAnswer = (field, value) => {
  if (value == null) return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return !value.name && !value.value;
  return String(value).trim() === "";
};

const isReadOnly = (form) =>
  Array.isArray(form?.fields) &&
  form.fields.length > 0 &&
  form.fields.every((f) => f.type === "video");

export function portalFormRows(deal, forms) {
  const portalForms = (deal && deal.portalForms) || {};
  return (forms || []).map((form) => {
    const entry = portalForms[form.id] || {};
    const submitted = !!entry.submittedAt;
    const started =
      !submitted &&
      (form.fields || []).some(
        (f) =>
          isFieldVisible(f, entry.answers || {}) &&
          !isEmptyAnswer(f, (entry.answers || {})[f.key]),
      );
    return {
      id: form.id,
      title: form.title || form.id,
      status: submitted ? "submitted" : started ? "started" : "not-started",
      submittedAt: entry.submittedAt || 0,
      pdfDriveFileId: entry.pdfDriveFileId || "",
      readOnly: isReadOnly(form),
    };
  });
}

// { submitted, total, allDone } counting only forms a client can submit.
export function portalFormProgress(rows) {
  const submittable = (rows || []).filter((r) => !r.readOnly);
  const submitted = submittable.filter((r) => r.status === "submitted").length;
  return {
    submitted,
    total: submittable.length,
    allDone: submittable.length > 0 && submitted === submittable.length,
  };
}
